import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import TransferJobService from "services/TransferJobService";


let initialState = { list: [], detail: [] };

export const getTransferJob = createAsyncThunk(
  "transferJob/getSurrogates",
  async () => {
    const response = await TransferJobService.getTransferJob();
    return response?.results;
  }
);


export const getTransferJobDetail = createAsyncThunk(
  "transferJob/getTransferJobDetail",
  async (body) => {
    const response = await TransferJobService.getTransferJobDetail(body);
    return response?.results;
  }
);



export const transferJobs = createAsyncThunk(
  "transferJob/transferJobs",
  async (body) => {
    const response = await TransferJobService.transferJobs(body);
    return response?.results;
  }
);





const transferJobSlice = createSlice({
  name: "transferJob",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getTransferJob, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(getTransferJobDetail, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(transferJobs, builder);

  },
});

export default transferJobSlice.reducer;

